<template>
  <a :href="link" target="_blank" class="py-1">
    <v-btn variant="outlined" size="small" color="success" style="background-color: white">
      Join
      <template #append>
        <GoogleMeet style="height: 20px; width: 20px" />
      </template>
      <v-tooltip activator="parent" location="bottom" class="custom-tooltip">Google Meet</v-tooltip>
    </v-btn>
  </a>
</template>

<script setup lang="ts">
import GoogleMeet from "@/assets/brand/googleMeet.svg";
defineProps<{ link: string }>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
